import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/app/hooks";
import { RootState } from "@/app/rootReducer";
import { downloadCampaignStatusCsvAction } from "../slices/campaignStatusDownloadCsvSlice";

export function useDownloadCsv(filters: Record<string, unknown>) {
  const dispatch = useAppDispatch();

  const { loading, error } = useSelector(
    (state: RootState) => state.campaignStatusDownloadCsv,
  );

  const downloadCsv = useCallback(() => {
    return dispatch(
      downloadCampaignStatusCsvAction({
        campaignStatusId: filters.campaignStatusId as number | undefined,
        companyName: filters.companyName as string | undefined,
      }),
    );
  }, [dispatch, filters]);

  return {
    downloadCsv,
    loading,
    error,
  };
}